import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { productService } from 'services';
import { Product } from 'types';
import { ServerStateKeysEnum } from '../constants';

export const useProductDetails = (slug: string, isDSOStore = false) => {
  return useQuery<Product, AxiosError>(
    `${ServerStateKeysEnum.productDetails}-${slug}`,
    () => {
      return productService.getProductDetails(slug, isDSOStore);
    },
    { staleTime: Infinity, enabled: !!slug }
  );
};
